export function throttle(callback, limit) {
    let wait = false; // Initially, we're not waiting
    return function fn() { // We return a throttled function
        if (!wait) { // If we're not waiting
            callback.call(); // Execute users function
            wait = true; // Prevent future invocations
            setTimeout(() => { // After a period of time
                wait = false; // And allow future invocations
            }, limit);
        }
    };
}

/**
 * This function returns a correctly formatted millisecond
 * value based on a numeric value taken from an ACF field
 *
 * @param {float} seconds Time in seconds
 * @returns {int} millisecond version
 */
export function getMillisecondAmount(seconds) {
    // If seconds is not a number or is less than 0, return false
    if ((typeof seconds !== 'number' && typeof seconds !== 'string') || Number.isNaN(parseFloat(seconds))) {
        return 'false';
    }
    const milliseconds = seconds * 1000;
    return milliseconds;
}
